function parseGigDateValue(value) {
  if (!value) return null;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function isGigCompleted(gig) {
  const status = String(gig?.status || '').toLowerCase();
  if (status !== 'published') return false;

  const end =
    parseGigDateValue(gig?.endsAtLocal)
    || parseGigDateValue(gig?.endsAtUtc)
    || parseGigDateValue(gig?.ends_at_utc)
    || parseGigDateValue(gig?.startsAtLocal)
    || parseGigDateValue(gig?.startsAtUtc)
    || parseGigDateValue(gig?.starts_at_utc);

  return !!end && end.getTime() <= Date.now();
}

export function getGigDisplayStatus(gig) {
  const status = String(gig?.status || 'draft').toLowerCase();
  return isGigCompleted(gig) ? 'completed' : status;
}

export function formatGigDisplayStatusLabel(gigOrStatus) {
  const status = typeof gigOrStatus === 'string'
    ? String(gigOrStatus || '').toLowerCase()
    : getGigDisplayStatus(gigOrStatus);

  if (status === 'completed') return 'Completed';
  return status
    .split('_')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ') || 'Draft';
}
